import script from "./PagesTop.vue?vue&type=script&setup=true&lang=js"
export * from "./PagesTop.vue?vue&type=script&setup=true&lang=js"

import "./PagesTop.vue?vue&type=style&index=0&id=7c91620a&lang=scss"

const __exports__ = script;

export default __exports__